//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <section class="go_wyn_container">
    <div class="go_wyn_header">
      {{ store.state.page.what_you_need.header }}
    </div>
    <div class="go_wyn_list_wrapper">
      <div class="go_wyn" v-for="(whatYouNeed, index) in wynList" :key="index">
        <component class="go_wyn_icon" :is="whatYouNeed.iconSrc" />
        <div class="go_title">
          {{ whatYouNeed.title }}
        </div>
        <div class="go_description">
          {{ whatYouNeed.description }}
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { ref } from "vue";
import { useStore } from "vuex";

import CardIcon from "@/components/icons/CardIcon.vue";
import PhoneIcon from "@/components/icons/PhoneIcon.vue";
import PCIcon from "@/components/icons/PCIcon.vue";
import GlassesIcon from "@/components/icons/GlassesIcon.vue";

const store = useStore();

const wynList = ref([
  {
    iconSrc: PhoneIcon,
    title: store.state.page.what_you_need.smartphone_title,
    description: store.state.page.what_you_need.smartphone_description,
  },
  {
    iconSrc: PCIcon,
    title: store.state.page.what_you_need.computer_title,
    description: store.state.page.what_you_need.computer_description,
  },
  {
    iconSrc: CardIcon,
    title: store.state.page.what_you_need.magnetic_card_title,
    description: store.state.page.what_you_need.magnetic_card_description,
  },
  {
    iconSrc: GlassesIcon,
    title: store.state.page.what_you_need.glasses_title,
    description: store.state.page.what_you_need.glasses_description,
  },
]);
</script>

<style lang="scss" scoped>
section.go_wyn_container {
  background: rgba(21, 25, 46, 0.05);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 95px;
  margin-bottom: 80px;
  padding: 70px 20px;

  @include tablet {
    margin-top: 86px;
    padding-top: 50px;
    padding-bottom: 50px;
    margin-bottom: 50px;
  }

  @include mobile {
    width: 400px;
    margin-top: 59px;
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .go_wyn_header {
    font-weight: 700;
    font-size: 29px;
    line-height: 30px;
    text-align: center;
    width: 100%;
    margin-bottom: 50px;

    @include tablet {
      font-size: 24px;
      line-height: 36px;
      margin-bottom: 52px;
    }

    @include mobile {
      width: 280px;
      font-size: 24px;
      line-height: 36px;
      margin-bottom: 0px;
    }
  }

  .go_wyn_list_wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
    flex-wrap: wrap;

    .go_wyn {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 214px;
      justify-content: space-between;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }

      @include tablet {
        width: 170px;
        margin-right: 30px;
      }

      @include mobile {
        width: 168px;
        margin-top: 50px;
      }

      .go_wyn_icon {
        @include tablet {
          height: 80px;
        }

        @include mobile {
          height: 80px;
        }
      }

      .go_title {
        margin-top: 27px;
        font-weight: 500;
        font-size: 24.3333px;
        line-height: 30px;

        @include tablet {
          margin-top: 22px;
          font-size: 20px;
          line-height: 25px;
        }

        @include mobile {
          margin-top: 22px;
          font-size: 20px;
          line-height: 25px;
        }
      }

      .go_description {
        font-weight: 300;
        font-size: 19.4667px;
        line-height: 24px;
        margin-top: 5px;

        @include tablet {
          font-size: 16px;
          line-height: 20px;
        }

        @include mobile {
          font-size: 15px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
